export const getPhotoLarge = (state) => state.auth.photos.large;
export const getPhotoSmall = (state) => state.auth.photos.small;
export const getUserId = (state) => state.auth.userId;
export const getIsAuth = (state) => state.auth.isAuth;
export const getLogin = (state) => state.auth.login;
export const getCaptchaUrl = (state) => state.auth.captchaUrl;